import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-75e910c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "caja-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "caja-content" };
const _hoisted_4 = { class: "page-header mb-4" };
const _hoisted_5 = { class: "header-left" };
const _hoisted_6 = { class: "header-icon" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "page-title" }, "Caja de Facturación Retail"),
    /*#__PURE__*/ _createElementVNode("p", { class: "page-subtitle" }, "Procesa pagos de mercancía despachada o gestiona devoluciones/cambios.")
], -1 /* HOISTED */));
const _hoisted_8 = { class: "caja-layout" };
const _hoisted_9 = { class: "orders-panel" };
const _hoisted_10 = { class: "panel-header" };
const _hoisted_11 = { class: "panel-title" };
const _hoisted_12 = { class: "count-badge" };
const _hoisted_13 = {
    key: 0,
    class: "search-wrapper-sm"
};
const _hoisted_14 = { class: "orders-list" };
const _hoisted_15 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "spinner-ring" }, null, -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = {
    key: 1,
    class: "empty-state text-muted"
};
const _hoisted_19 = { key: 2 };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "order-top" };
const _hoisted_22 = { class: "order-code" };
const _hoisted_23 = { class: "order-client" };
const _hoisted_24 = { class: "order-bottom" };
const _hoisted_25 = { class: "order-meta" };
const _hoisted_26 = { class: "order-total" };
const _hoisted_27 = { class: "details-panel" };
const _hoisted_28 = {
    key: 0,
    class: "empty-selection"
};
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", null, "Selecciona una orden", -1 /* HOISTED */));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Para ver sus artículos y procesar el cobro o gestionar devoluciones.", -1 /* HOISTED */));
const _hoisted_31 = {
    key: 1,
    class: "details-content"
};
const _hoisted_32 = { class: "detail-header" };
const _hoisted_33 = { class: "header-info" };
const _hoisted_34 = { class: "client-name" };
const _hoisted_35 = { class: "header-actions" };
const _hoisted_36 = {
    key: 0,
    class: "warning-banner"
};
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Esperando Almacén", -1 /* HOISTED */));
const _hoisted_38 = { class: "total-big" };
const _hoisted_39 = { class: "detail-body" };
const _hoisted_40 = { class: "table-scroll" };
const _hoisted_41 = { class: "data-table" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Producto"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Cant."),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "P.U ($)"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "Subtotal"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Acción")
    ])
], -1 /* HOISTED */));
const _hoisted_43 = { class: "product-name" };
const _hoisted_44 = { class: "text-center fw-bold" };
const _hoisted_45 = { class: "text-end font-mono" };
const _hoisted_46 = { class: "text-end fw-bold font-mono text-success" };
const _hoisted_47 = { class: "text-center" };
const _hoisted_48 = ["onClick", "disabled"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
    key: 0,
    class: "empty-state sm text-danger"
};
const _hoisted_51 = {
    key: 0,
    class: "payment-section mt-4"
};
const _hoisted_52 = { class: "payment-section-header" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "section-title" }, "Cobro", -1 /* HOISTED */));
const _hoisted_54 = ["disabled"];
const _hoisted_55 = { class: "payment-lines" };
const _hoisted_56 = { class: "payment-line-header-touch" };
const _hoisted_57 = { class: "payment-index" };
const _hoisted_58 = {
    key: 0,
    class: "method-selected-name"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = { class: "touch-chips-container" };
const _hoisted_61 = ["onClick"];
const _hoisted_62 = {
    key: 0,
    class: "touch-amount-row"
};
const _hoisted_63 = { class: "monto-input-wrapper-touch" };
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "monto-prefix-touch" }, "$", -1 /* HOISTED */));
const _hoisted_65 = ["onUpdate:modelValue"];
const _hoisted_66 = {
    key: 1,
    class: "payment-extra-touch"
};
const _hoisted_67 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_68 = ["onUpdate:modelValue"];
const _hoisted_69 = ["onUpdate:modelValue"];
const _hoisted_70 = ["onUpdate:modelValue"];
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: null }, "Banco emisor...", -1 /* HOISTED */));
const _hoisted_72 = ["value"];
const _hoisted_73 = {
    key: 4,
    class: "monto-input-wrapper-touch bs-border"
};
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "monto-prefix-touch bs" }, "Bs.", -1 /* HOISTED */));
const _hoisted_75 = ["onUpdate:modelValue"];
const _hoisted_76 = {
    key: 5,
    class: "vuelto-box-touch"
};
const _hoisted_77 = { class: "vuelto-label-touch" };
const _hoisted_78 = { class: "payment-summary" };
const _hoisted_79 = { class: "summary-row" };
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Total orden:", -1 /* HOISTED */));
const _hoisted_81 = { class: "total-value" };
const _hoisted_82 = { class: "summary-row" };
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Ingresado (Bruto):", -1 /* HOISTED */));
const _hoisted_84 = { class: "total-value" };
const _hoisted_85 = {
    key: 0,
    class: "summary-row"
};
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Vuelto total (Efectivo):", -1 /* HOISTED */));
const _hoisted_87 = { class: "vuelto-total" };
const _hoisted_88 = {
    key: 1,
    class: "summary-row pending"
};
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Falta:", -1 /* HOISTED */));
const _hoisted_90 = {
    key: 2,
    class: "summary-row pending"
};
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Exceso de pago (No permitido):", -1 /* HOISTED */));
const _hoisted_92 = {
    key: 1,
    class: "info-bill-card mt-4"
};
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "section-title" }, "Información de Facturación", -1 /* HOISTED */));
const _hoisted_94 = { class: "info-grid mt-3" };
const _hoisted_95 = { class: "info-item" };
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Método de cobro", -1 /* HOISTED */));
const _hoisted_97 = { class: "info-value" };
const _hoisted_98 = { class: "info-item" };
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "info-label" }, "Procesado", -1 /* HOISTED */));
const _hoisted_100 = { class: "info-value" };
const _hoisted_101 = { class: "hint-box mt-3 warning" };
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Para cambios parciales, use el botón \"Devolver\" en cada línea. El botón de abajo anulará TODA la factura.", -1 /* HOISTED */));
const _hoisted_103 = { class: "detail-footer" };
const _hoisted_104 = ["disabled"];
const _hoisted_105 = ["disabled"];
const _hoisted_106 = { class: "modal-header-premium outline-danger" };
const _hoisted_107 = { class: "modal-title-group" };
const _hoisted_108 = { class: "modal-icon text-danger bg-red-light" };
const _hoisted_109 = { class: "modal-title-text" };
const _hoisted_110 = { class: "modal-subtitle" };
const _hoisted_111 = { class: "modal-body p-4" };
const _hoisted_112 = { class: "mb-4 text-muted" };
const _hoisted_113 = { class: "reasons-grid" };
const _hoisted_114 = ["value"];
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "reason-indicator" }, null, -1 /* HOISTED */));
const _hoisted_116 = { class: "reason-content" };
const _hoisted_117 = { class: "reason-title" };
const _hoisted_118 = { class: "reason-desc" };
const _hoisted_119 = { class: "modal-footer" };
const _hoisted_120 = ["disabled"];
const _hoisted_121 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    const _component_CoinsIcon = _resolveComponent("CoinsIcon");
    const _component_SearchIcon = _resolveComponent("SearchIcon");
    const _component_FileTextIcon = _resolveComponent("FileTextIcon");
    const _component_UserIcon = _resolveComponent("UserIcon");
    const _component_ShoppingCartIcon = _resolveComponent("ShoppingCartIcon");
    const _component_PointerIcon = _resolveComponent("PointerIcon");
    const _component_LoaderIcon = _resolveComponent("LoaderIcon");
    const _component_RefreshCwIcon = _resolveComponent("RefreshCwIcon");
    const _component_TrashIcon = _resolveComponent("TrashIcon");
    const _component_PlusCircleIcon = _resolveComponent("PlusCircleIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_AlertCircleIcon = _resolveComponent("AlertCircleIcon");
    const _component_LockIcon = _resolveComponent("LockIcon");
    const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon");
    const _component_XOctagonIcon = _resolveComponent("XOctagonIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Sidebar),
            _createElementVNode("div", _hoisted_3, [
                _createCommentVNode(" ── Page Header ── "),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_CoinsIcon, { size: 24 })
                        ]),
                        _hoisted_7
                    ]),
                    _createElementVNode("button", {
                        class: _normalizeClass(["btn-toggle-mode", _ctx.modoHistorial ? 'mode-history' : 'mode-pending']),
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.toggleHistorial && _ctx.toggleHistorial(...args)))
                    }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modoHistorial ? _ctx.ListIcon : _ctx.SearchIcon), { size: 16 })),
                        _createTextVNode(" " + _toDisplayString(_ctx.modoHistorial ? 'Volver a Pendientes' : 'Historial / Devoluciones'), 1 /* TEXT */)
                    ], 2 /* CLASS */)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createCommentVNode(" ── LEFT PANEL: Lista de Órdenes ── "),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("h5", _hoisted_11, [
                                _createTextVNode(_toDisplayString(_ctx.modoHistorial ? 'Facturas Emitidas' : 'Por Cobrar') + " ", 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.ordenesVisibles.length), 1 /* TEXT */)
                            ]),
                            (_ctx.modoHistorial)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_SearchIcon, {
                                        size: 14,
                                        class: "search-icon"
                                    }),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "search-input-sm",
                                        placeholder: "Código o Cliente...",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.filtroCodigo) = $event))
                                    }, null, 512 /* NEED_PATCH */), [
                                        [_vModelText, _ctx.filtroCodigo]
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                                : (_ctx.ordenesVisibles.length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createVNode(_component_FileTextIcon, {
                                            size: 32,
                                            class: "text-muted"
                                        }),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.modoHistorial ? 'No se encontraron facturas.' : 'No hay órdenes listas para cobro.'), 1 /* TEXT */)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordenesVisibles, (orden) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: orden.ordenVentaId,
                                                class: _normalizeClass(["order-item", { 'selected': _ctx.ordenSeleccionada?.ordenVentaId === orden.ordenVentaId }]),
                                                onClick: ($event) => (_ctx.seleccionarOrden(orden))
                                            }, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("strong", _hoisted_22, _toDisplayString(orden.codigoOrden), 1 /* TEXT */),
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["status-pill sm", _ctx.statusClass(orden.estado)])
                                                    }, _toDisplayString(_ctx.statusLabel(orden.estado)), 3 /* TEXT, CLASS */)
                                                ]),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createVNode(_component_UserIcon, {
                                                        size: 14,
                                                        class: "text-muted"
                                                    }),
                                                    _createTextVNode(" " + _toDisplayString(orden.nombreCliente), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createElementVNode("span", _hoisted_25, [
                                                        _createVNode(_component_ShoppingCartIcon, { size: 13 }),
                                                        _createTextVNode(" " + _toDisplayString(orden.detalles.length) + " ítems ", 1 /* TEXT */)
                                                    ]),
                                                    _createElementVNode("span", _hoisted_26, "$" + _toDisplayString(orden.totalDolares.toFixed(2)), 1 /* TEXT */)
                                                ])
                                            ], 10 /* CLASS, PROPS */, _hoisted_20));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                        ])
                    ]),
                    _createCommentVNode(" ── RIGHT PANEL: Detalle y Acciones ── "),
                    _createElementVNode("div", _hoisted_27, [
                        (!_ctx.ordenSeleccionada)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _createVNode(_component_PointerIcon, {
                                    size: 48,
                                    class: "text-muted"
                                }),
                                _hoisted_29,
                                _hoisted_30
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createCommentVNode(" Detail Header "),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("h4", null, [
                                            _createTextVNode(_toDisplayString(_ctx.modoHistorial ? 'Detalle de Factura' : 'Procesar Orden') + " ", 1 /* TEXT */),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.ordenSeleccionada.codigoOrden), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("span", _hoisted_34, [
                                            _createVNode(_component_UserIcon, { size: 15 }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.ordenSeleccionada.nombreCliente), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                        (_ctx.ordenSeleccionada.estado === 'PendienteReingreso')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                                _createVNode(_component_LoaderIcon, {
                                                    size: 14,
                                                    class: "spin"
                                                }),
                                                _hoisted_37,
                                                _createElementVNode("button", {
                                                    class: "btn-icon-sm ml-2",
                                                    title: "Actualizar Estado",
                                                    onClick: _cache[2] || (_cache[2] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.consultarEstado && _ctx.consultarEstado(...args)))
                                                }, [
                                                    _createVNode(_component_RefreshCwIcon, { size: 14 })
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_38, "$" + _toDisplayString(_ctx.totalCalculado.toFixed(2)), 1 /* TEXT */)
                                    ])
                                ]),
                                _createCommentVNode(" Content Scroll "),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("table", _hoisted_41, [
                                            _hoisted_42,
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ordenSeleccionada.detalles, (item, index) => {
                                                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("span", _hoisted_43, _toDisplayString(item.nombreProducto), 1 /* TEXT */)
                                                        ]),
                                                        _createElementVNode("td", _hoisted_44, _toDisplayString(item.cantidad), 1 /* TEXT */),
                                                        _createElementVNode("td", _hoisted_45, "$" + _toDisplayString(item.precioUnitarioUsd.toFixed(2)), 1 /* TEXT */),
                                                        _createElementVNode("td", _hoisted_46, "$" + _toDisplayString((item.cantidad *
                                                            item.precioUnitarioUsd).toFixed(2)), 1 /* TEXT */),
                                                        _createElementVNode("td", _hoisted_47, [
                                                            _createCommentVNode(" Remover antes de cobrar "),
                                                            (!_ctx.modoHistorial)
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 0,
                                                                    class: "btn-action-sm danger",
                                                                    title: "Remover (Regresar a almacén)",
                                                                    onClick: ($event) => (_ctx.removerItem(index)),
                                                                    disabled: _ctx.ordenSeleccionada.estado === 'PendienteReingreso'
                                                                }, [
                                                                    _createVNode(_component_TrashIcon, { size: 14 })
                                                                ], 8 /* PROPS */, _hoisted_48))
                                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                    _createCommentVNode(" Devolver después de cobrado "),
                                                                    _createElementVNode("button", {
                                                                        class: "btn-action-sm warning",
                                                                        title: "Generar nota de crédito parcial",
                                                                        onClick: ($event) => (_ctx.abrirModalMotivo('parcial', item))
                                                                    }, [
                                                                        _createVNode(_component_RefreshCwIcon, { size: 14 }),
                                                                        _createTextVNode(" Devolver ")
                                                                    ], 8 /* PROPS */, _hoisted_49)
                                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                        ])
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ])
                                        ]),
                                        (_ctx.ordenSeleccionada.detalles.length === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, " El carrito está vacío. "))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _createCommentVNode(" ── Panel Multipago ── "),
                                    (!_ctx.modoHistorial)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                                _hoisted_53,
                                                _createElementVNode("button", {
                                                    class: "btn-add-payment-touch",
                                                    onClick: _cache[3] || (_cache[3] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.agregarPago && _ctx.agregarPago(...args))),
                                                    disabled: _ctx.pagoCompleto
                                                }, [
                                                    _createVNode(_component_PlusCircleIcon, { size: 18 }),
                                                    _createTextVNode(" Agregar Otro Método de Pago ")
                                                ], 8 /* PROPS */, _hoisted_54)
                                            ]),
                                            _createElementVNode("div", _hoisted_55, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagos, (p, i) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: i,
                                                        class: "payment-line-touch"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_56, [
                                                            _createElementVNode("span", _hoisted_57, [
                                                                _createTextVNode("Cobro #" + _toDisplayString(i + 1) + " ", 1 /* TEXT */),
                                                                (p.tipoPagoId !== 0)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, "- " + _toDisplayString(_ctx.getTipoPago(p.tipoPagoId)?.nombre), 1 /* TEXT */))
                                                                    : _createCommentVNode("v-if", true)
                                                            ]),
                                                            (_ctx.pagos.length > 1)
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 0,
                                                                    class: "btn-remove-pay-header",
                                                                    onClick: ($event) => (_ctx.pagos.splice(i, 1))
                                                                }, [
                                                                    _createVNode(_component_XIcon, { size: 15 }),
                                                                    _createTextVNode(" Quitar ")
                                                                ], 8 /* PROPS */, _hoisted_59))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _createCommentVNode(" Botones Touch de Método "),
                                                        _createElementVNode("div", _hoisted_60, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiposPago, (t) => {
                                                                return (_openBlock(), _createElementBlock("button", {
                                                                    key: t.tipoPagoId,
                                                                    class: _normalizeClass(["touch-chip", { 'active': p.tipoPagoId === t.tipoPagoId }]),
                                                                    onClick: ($event) => { p.tipoPagoId = t.tipoPagoId; _ctx.onChangeTipoPago(p); }
                                                                }, _toDisplayString(t.nombre), 11 /* TEXT, CLASS, PROPS */, _hoisted_61));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ]),
                                                        _createCommentVNode(" Monto "),
                                                        (p.tipoPagoId !== 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                                _createElementVNode("div", _hoisted_63, [
                                                                    _hoisted_64,
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        type: "number",
                                                                        class: "pay-input-touch",
                                                                        "onUpdate:modelValue": ($event) => ((p.monto) = $event),
                                                                        min: "0",
                                                                        step: "0.01",
                                                                        placeholder: "Monto a Cobrar ($)"
                                                                    }, null, 8 /* PROPS */, _hoisted_65), [
                                                                        [
                                                                            _vModelText,
                                                                            p.monto,
                                                                            void 0,
                                                                            { number: true }
                                                                        ]
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createCommentVNode(" Campos Extra Touch "),
                                                        (_ctx.getTipoPago(p.tipoPagoId))
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                                (_ctx.getTipoPago(p.tipoPagoId)?.requiereReferencia)
                                                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                        key: 0,
                                                                        type: "text",
                                                                        class: "extra-input-touch",
                                                                        "onUpdate:modelValue": ($event) => ((p.referencia) = $event),
                                                                        placeholder: _ctx.getTipoPago(p.tipoPagoId)?.nombre === 'Zelle' ? 'Código de confirmación' : 'Referencia (últimos dígitos)'
                                                                    }, null, 8 /* PROPS */, _hoisted_67)), [
                                                                        [_vModelText, p.referencia]
                                                                    ])
                                                                    : _createCommentVNode("v-if", true),
                                                                (_ctx.getTipoPago(p.tipoPagoId)?.requiereTitular)
                                                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                        key: 1,
                                                                        type: "text",
                                                                        class: "extra-input-touch",
                                                                        "onUpdate:modelValue": ($event) => ((p.titular) = $event),
                                                                        placeholder: "Titular de la cuenta"
                                                                    }, null, 8 /* PROPS */, _hoisted_68)), [
                                                                        [_vModelText, p.titular]
                                                                    ])
                                                                    : _createCommentVNode("v-if", true),
                                                                (_ctx.getTipoPago(p.tipoPagoId)?.requiereReferencia)
                                                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                        key: 2,
                                                                        type: "date",
                                                                        class: "extra-input-touch",
                                                                        "onUpdate:modelValue": ($event) => ((p.fechaTransaccion) = $event)
                                                                    }, null, 8 /* PROPS */, _hoisted_69)), [
                                                                        [_vModelText, p.fechaTransaccion]
                                                                    ])
                                                                    : _createCommentVNode("v-if", true),
                                                                (_ctx.getTipoPago(p.tipoPagoId)?.requiereBanco)
                                                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                        key: 3,
                                                                        class: "extra-input-touch",
                                                                        "onUpdate:modelValue": ($event) => ((p.bancoId) = $event)
                                                                    }, [
                                                                        _hoisted_71,
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBancos(p.tipoPagoId), (b) => {
                                                                            return (_openBlock(), _createElementBlock("option", {
                                                                                key: b.bancoId,
                                                                                value: b.bancoId
                                                                            }, _toDisplayString(b.nombre), 9 /* TEXT, PROPS */, _hoisted_72));
                                                                        }), 128 /* KEYED_FRAGMENT */))
                                                                    ], 8 /* PROPS */, _hoisted_70)), [
                                                                        [_vModelSelect, p.bancoId]
                                                                    ])
                                                                    : _createCommentVNode("v-if", true),
                                                                (_ctx.getTipoPago(p.tipoPagoId)?.permiteMontoBs)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                                                        _hoisted_74,
                                                                        _withDirectives(_createElementVNode("input", {
                                                                            type: "number",
                                                                            class: "pay-input-touch",
                                                                            "onUpdate:modelValue": ($event) => ((p.montoBs) = $event),
                                                                            min: "0",
                                                                            placeholder: "Monto en Bolívares"
                                                                        }, null, 8 /* PROPS */, _hoisted_75), [
                                                                            [
                                                                                _vModelText,
                                                                                p.montoBs,
                                                                                void 0,
                                                                                { number: true }
                                                                            ]
                                                                        ])
                                                                    ]))
                                                                    : _createCommentVNode("v-if", true),
                                                                (_ctx.getTipoPago(p.tipoPagoId)?.nombre === 'Efectivo')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                                        _createElementVNode("span", _hoisted_77, "Vuelto: $" + _toDisplayString(_ctx.calcularVuelto(p).toFixed(2)), 1 /* TEXT */)
                                                                    ]))
                                                                    : _createCommentVNode("v-if", true)
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]),
                                            _createElementVNode("div", _hoisted_78, [
                                                _createElementVNode("div", _hoisted_79, [
                                                    _hoisted_80,
                                                    _createElementVNode("span", _hoisted_81, "$" + _toDisplayString(_ctx.totalCalculado.toFixed(2)), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_82, [
                                                    _hoisted_83,
                                                    _createElementVNode("span", _hoisted_84, "$" + _toDisplayString(_ctx.totalPagado.toFixed(2)), 1 /* TEXT */)
                                                ]),
                                                (_ctx.vueltoTotal > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                        _hoisted_86,
                                                        _createElementVNode("span", _hoisted_87, "$" + _toDisplayString(_ctx.vueltoTotal.toFixed(2)), 1 /* TEXT */)
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                (!_ctx.pagoCompleto && (_ctx.totalPagado - _ctx.vueltoTotal) < _ctx.totalCalculado)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                                        _hoisted_89,
                                                        _createElementVNode("span", null, "$" + _toDisplayString((_ctx.totalCalculado - (_ctx.totalPagado - _ctx.vueltoTotal)).toFixed(2)), 1 /* TEXT */)
                                                    ]))
                                                    : _createCommentVNode("v-if", true),
                                                (!_ctx.pagoCompleto && (_ctx.totalPagado - _ctx.vueltoTotal) > _ctx.totalCalculado)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                                        _hoisted_91,
                                                        _createElementVNode("span", null, "$" + _toDisplayString(((_ctx.totalPagado - _ctx.vueltoTotal) - _ctx.totalCalculado).toFixed(2)), 1 /* TEXT */)
                                                    ]))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                            _hoisted_93,
                                            _createElementVNode("div", _hoisted_94, [
                                                _createElementVNode("div", _hoisted_95, [
                                                    _hoisted_96,
                                                    _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.ordenSeleccionada.metodoPago || 'Zelle'), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("div", _hoisted_98, [
                                                    _hoisted_99,
                                                    _createElementVNode("span", _hoisted_100, _toDisplayString(new Date(_ctx.ordenSeleccionada.fechaFacturacion ||
                                                        _ctx.ordenSeleccionada.fechaCreacion).toLocaleString()), 1 /* TEXT */)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_101, [
                                                _createVNode(_component_AlertCircleIcon, { size: 18 }),
                                                _hoisted_102
                                            ])
                                        ]))
                                ]),
                                _createCommentVNode(" Bottom Actions "),
                                _createElementVNode("div", _hoisted_103, [
                                    _createElementVNode("button", {
                                        class: "btn-secondary-lg",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.ordenSeleccionada = null))
                                    }, "Cerrar"),
                                    (!_ctx.modoHistorial)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn-primary-lg flex-1",
                                            onClick: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => (_ctx.facturar && _ctx.facturar(...args))),
                                            disabled: !_ctx.pagoCompleto || _ctx.facturando || _ctx.ordenSeleccionada.estado === 'PendienteReingreso' || _ctx.ordenSeleccionada.detalles.length === 0
                                        }, [
                                            (_ctx.facturando)
                                                ? (_openBlock(), _createBlock(_component_LoaderIcon, {
                                                    key: 0,
                                                    size: 20,
                                                    class: "spin"
                                                }))
                                                : (_ctx.ordenSeleccionada.estado === 'PendienteReingreso')
                                                    ? (_openBlock(), _createBlock(_component_LockIcon, {
                                                        key: 1,
                                                        size: 20
                                                    }))
                                                    : (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                                                        key: 2,
                                                        size: 20
                                                    })),
                                            _createTextVNode(" " + _toDisplayString(_ctx.facturando ? 'Procesando...' : (_ctx.ordenSeleccionada.estado === 'PendienteReingreso' ? 'Bloqueado por Reingreso' : `Cobrar $${_ctx.totalCalculado.toFixed(2)}`)), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_104))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "btn-danger-lg flex-1",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.abrirModalMotivo('total'))),
                                            disabled: _ctx.anulando
                                        }, [
                                            (_ctx.anulando)
                                                ? (_openBlock(), _createBlock(_component_LoaderIcon, {
                                                    key: 0,
                                                    size: 20,
                                                    class: "spin"
                                                }))
                                                : (_openBlock(), _createBlock(_component_XOctagonIcon, {
                                                    key: 1,
                                                    size: 20
                                                })),
                                            _createTextVNode(" " + _toDisplayString(_ctx.anulando ? 'Anulando...' : 'Anular Factura Completa'), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_105))
                                ])
                            ]))
                    ])
                ])
            ])
        ]),
        _createCommentVNode(" ── MODAL MOTIVO DE DEVOLUCIÓN ── "),
        _createVNode(_Transition, { name: "modal-fade" }, {
            default: _withCtx(() => [
                (_ctx.mostrarModalMotivo)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-overlay",
                        onClick: _cache[12] || (_cache[12] =
                            //@ts-ignore
                            (...args) => (_ctx.cerrarModalMotivo && _ctx.cerrarModalMotivo(...args)))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-window",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, [
                                    _createElementVNode("div", _hoisted_108, [
                                        _createVNode(_component_AlertCircleIcon, { size: 20 })
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h2", _hoisted_109, _toDisplayString(_ctx.modalConfig.titulo), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.modalConfig.subtitulo), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => (_ctx.cerrarModalMotivo && _ctx.cerrarModalMotivo(...args))),
                                    class: "btn-modal-close"
                                }, [
                                    _createVNode(_component_XIcon, { size: 20 })
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.modalConfig.descripcion), 1 /* TEXT */),
                                _createCommentVNode(" Selección de Motivo "),
                                _createElementVNode("div", _hoisted_113, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalConfig.opciones, (opcion) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                            class: _normalizeClass(["reason-card", { 'selected': _ctx.motivoSeleccionado === opcion.valor }]),
                                            key: opcion.valor
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                value: opcion.valor,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.motivoSeleccionado) = $event)),
                                                hidden: ""
                                            }, null, 8 /* PROPS */, _hoisted_114), [
                                                [_vModelRadio, _ctx.motivoSeleccionado]
                                            ]),
                                            _hoisted_115,
                                            _createElementVNode("div", _hoisted_116, [
                                                _createElementVNode("span", _hoisted_117, _toDisplayString(opcion.titulo), 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_118, _toDisplayString(opcion.descripcion), 1 /* TEXT */)
                                            ])
                                        ], 2 /* CLASS */));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_119, [
                                _createElementVNode("button", {
                                    class: "btn-modal-cancel",
                                    onClick: _cache[9] || (_cache[9] =
                                        //@ts-ignore
                                        (...args) => (_ctx.cerrarModalMotivo && _ctx.cerrarModalMotivo(...args))),
                                    disabled: _ctx.procesandoModal
                                }, "Cancelar", 8 /* PROPS */, _hoisted_120),
                                _createElementVNode("button", {
                                    class: "btn-primary-lg ml-2",
                                    style: { "background": "linear-gradient(135deg, #ef4444, #dc2626)", "box-shadow": "0 4px 14px rgba(239,68,68,0.3)" },
                                    onClick: _cache[10] || (_cache[10] =
                                        //@ts-ignore
                                        (...args) => (_ctx.confirmarMotivo && _ctx.confirmarMotivo(...args))),
                                    disabled: !_ctx.motivoSeleccionado || _ctx.procesandoModal
                                }, [
                                    (_ctx.procesandoModal)
                                        ? (_openBlock(), _createBlock(_component_LoaderIcon, {
                                            key: 0,
                                            size: 18,
                                            class: "spin"
                                        }))
                                        : (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                                            key: 1,
                                            size: 18
                                        })),
                                    _createTextVNode(" Confirmar ")
                                ], 8 /* PROPS */, _hoisted_121)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
        })
    ]));
}
